<template>
  <v-container class="" id="dashboard" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card color="primary" inline title="Filtros">
          <v-row>
            <v-col cols="12" sm="4">
              <v-select
                dense
                label="Cobrados"
                v-model="filtros.cobrados"
                multiple
                :items="filtrosCobrados"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                dense
                label="Modo"
                v-model="filtros.modos"
                multiple
                :items="filtrosModo"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                dense
                label="Formas Pago"
                v-model="filtros.formasPago"
                multiple
                :items="filtrosFormaPago"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                dense
                label="Restaurantes"
                v-model="filtros.restaurantes"
                multiple
                :items="filtrosRestaurantes"
              />
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="info"
          icon="mdi-currency-eur"
          title="Ventas total"
          :value="mostrarMoneda(pedidosTotal)"
          data1="Nº de pedidos"
          :data1-value="numeroPedidosTotal.toString()"
          data2="Total en tienda"
          :data2-value="mostrarMoneda(totalPedidosTpv)"
          data3="Total en Online"
          :data3-value="mostrarMoneda(totalPedidosOnline.toString())"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        /> </v-col
      ><v-col class="py-0" cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="primary"
          icon="mdi-currency-eur"
          title="Ventas en tienda"
          :value="mostrarMoneda(totalPedidosTpv)"
          data1="Nº de pedidos"
          :data1-value="numeroPedidosTpv.toString()"
          data2="Domicilio"
          :data2-value="
            pedidosTpvContabilizar
              .filter((p) => p.modo == 'recoger')
              .length.toString()
          "
          data3="Recogida"
          :data3-value="
            pedidosTpvContabilizar
              .filter((p) => p.modo == 'recoger')
              .length.toString()
          "
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>
      <v-col class="py-0" cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="#56a7a8"
          icon="mdi-currency-eur"
          title="Ventas FunEats"
          :value="mostrarMoneda(totalPedidosOnline, true)"
          data1="Total de pedidos"
          :data1-value="pedidosOnlineContabilizar.length.toString()"
          data2="Domicilio"
          :data2-value="
            pedidosOnlineContabilizar
              .filter((p) => p.modo == 'domicilio')
              .length.toString()
          "
          data3="Recogida"
          :data3-value="
            pedidosOnlineContabilizar
              .filter((p) => p.modo == 'recoger')
              .length.toString()
          "
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>
      <!--
      <v-col class="py-0" cols="12" sm="6" lg="3">
        <base-material-stats-card
          color="#f27700"
          icon="mdi-currency-eur"
          title="Ventas Just Eat"
          value="357,53"
          data1="Nº de pedidos"
          data1-value="21"
          data2="Domicilio"
          data2-value="234.50"
          data3="Recogida"
          data3-value="80.43"
          sub-icon="mdi-clock"
          sub-text="En el día de hoy"
        />
      </v-col>-->
      <v-col cols="12" class="text-right" v-if="false">
        <div class="mt-sm-n2">
          <v-btn
            text
            fab
            :small="$vuetify.breakpoint.xs"
            color="rgba(0, 0, 0, 0.54)"
            @click="filtrosAcordeon = filtrosAcordeon.length > 0 ? [] : [0]"
          >
            <div class="d-flex flex-column align-center">
              <v-icon>mdi-filter</v-icon>
              <p class="mb-0 text-caption">Filtros</p>
            </div>
          </v-btn>
        </div>
      </v-col>

      <v-col cols="12">
        <base-material-card color="primary" inline title="Ventas en tienda">
          <v-row no-gutters class="text-no-wrap" align="center">
            <v-col cols="12"
              ><v-data-table
                :items-per-page="10"
                :items="getPedidosListadoBossNegocioTpv"
              >
                <template v-slot:header="{ item, index }">
                  <thead>
                    <tr>
                      <th class="primary--text">Restaurante</th>
                      <th class="primary--text">Modo</th>
                      <th class="primary--text">Mesa</th>
                      <th class="primary--text">Tiempo</th>
                      <th class="primary--text">Estado</th>
                      <th class="primary--text">Comensales</th>
                      <th class="text-right primary--text">Precio</th>
                      <!-- <th class="text-right primary--text">Menú</th> -->
                    </tr>
                  </thead>
                </template>
                <template v-slot:item="{ item, index }">
                  <tr
                    :class="
                      item.eliminado
                        ? 'red lighten-3'
                        : !item.cobrado
                        ? 'blue lighten-5'
                        : ''
                    "
                    @click="goView(item)"
                    class="tr-click"
                  >
                    <!-- <td>{{ i }}</td> -->
                    <td>{{ item.copyRest.nombre }}</td>
                    <td>{{ item.nombreModo }}</td>
                    <td>
                      <span v-if="item.numPedidoRestDia < 10">0</span
                      >{{ item.numPedidoRestDia }}
                    </td>
                    <td>{{ item.fechaMostrarContador }}</td>
                    <td>
                      <span
                        class="font-weight-bold success--text"
                        v-if="!!item.cobrado"
                        >Cobrado</span
                      >
                      <span v-else>Por cobrar</span>
                    </td>
                    <td>{{ item.comensales }}</td>
                    <td class="text-right font-weight-bold">
                      {{ item.cantidadMostrar }}€
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
      <v-dialog
        v-model="mesaDialogo"
        transition="dialog-top-transition"
        :max-width="$vuetify.breakpoint.mdAndUp ? 400 : ''"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        scrollable
      >
        <v-card>
          <v-card-title
            class="text-left"
            :class="$vuetify.breakpoint.mdAndUp ? 'pb-6' : 'py-2'"
            style="word-break: normal"
          >
            <v-row>
              <v-col cols="7">
                <!-- {{ datosPedido.copyRest.nombre }} -->
                <div class="display-3 font-weight-bold">
                  {{ datosPedido.copyRest ? datosPedido.copyRest.nombre : "-" }}
                </div>
                <div class="font-weight-regular">
                  {{ datosPedido.nombreModo }}
                  <span class="primary--text font-weight-bold">
                    <span v-if="datosPedido.numPedidoRestDia < 10">0</span
                    >{{ datosPedido.numPedidoRestDia }}
                  </span>
                </div>
              </v-col>
              <v-col cols="5" class="text-right">
                <div class="display-3 primary--text font-weight-bold">
                  <sup>€</sup>
                  {{ datosPedido.cantidadMostrar }}
                </div>
                <div>
                  <span
                    class="font-weight-bold success--text"
                    v-if="!!datosPedido.cobrado"
                    >cobrado</span
                  >
                  <span v-else>por cobrar</span>
                </div>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-list class="pa-0" two-line dense>
              <template v-for="(prod, i) in datosPedido.productos">
                <v-list-item :key="prod.id">
                  <v-list-item-action style="max-width: 24px">
                    x{{ prod.cantidad }}
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ prod.nombre }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="caption">{{
                      prod.categoria
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action style="max-width: 24px">
                    {{ prod.precioProductoTotal + "€" }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  inset
                  v-if="i !== datosPedido.productos.length - 1"
                  :key="i"
                />
              </template>
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions class="justify-end">
            <div>
              <v-icon left class="mt-n1" color="secondary">
                mdi-clock-outline
              </v-icon>
              {{ datosPedido.fechaMostrarContador }}'
            </div>
            <v-spacer />
            <v-btn class="mr-0" color="secondary" @click="mesaDialogo = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-col cols="12">
        <base-material-card color="#56a7a8" inline title="Ventas en Online">
          <v-row no-gutters class="text-no-wrap" align="center"
            ><v-col cols="12"
              ><v-simple-table>
                <thead>
                  <tr>
                    <th class="primary--text">#</th>
                    <th class="primary--text">Agregador</th>
                    <th class="primary--text">Modo</th>
                    <th class="primary--text">Pago</th>
                    <th class="primary--text">Precio</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(p, i) in getPedidosListadoBossNegocioOnline"
                    :key="i"
                    :class="i % 2 == 0 ? 'grey lighten-5' : ''"
                    class="tr-click"
                    @click="goView(p)"
                  >
                    <td>{{ p.numPedidoRestDia }}</td>
                    <td class="">
                      <v-img
                        max-width="90"
                        class="pa-0 ma-0"
                        :src="imgCanal(p.canalVenta)"
                        aspect-ratio="1.7"
                        height="30"
                        contain
                      ></v-img>
                    </td>
                    <td>{{ p.modo }}</td>
                    <td>{{ p.formaPago }}</td>
                    <td class="font-weight-bold">{{ p.cantidadMostrar }} €</td>
                    <!--<td class="text-right">
                      <v-btn class="px-2 ml-1" color="info" min-width="0" small>
                        <v-icon small>mdi-eye-outline</v-icon>
                      </v-btn>
                    </td>-->
                  </tr>
                </tbody>
              </v-simple-table></v-col
            >
          </v-row>
        </base-material-card>
      </v-col>
      <v-col cols="12">
        <base-material-card color="#56a7a8" inline title="Mejores productos">
          <v-row no-gutters class="text-no-wrap" align="center"
            ><v-col cols="12">
              <v-data-table
                :items-per-page="10"
                :items="productosMejores"
                :headers="productosMejoresCabecera"
                sort-desc=""
                sort-by="total"
              >
                <template v-slot:item="{ item, index }">
                  <tr :class="index % 2 == 0 ? 'grey lighten-5' : ''">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.nombre }}</td>
                    <td>{{ item.cantidad }}</td>
                    <td class="font-weight-bold">{{ item.totalMostrar }} €</td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
      <!--componente cierre-->
      <!--<v-col id="cierre">
        
        <cierre-vista :datos="{}" />
      </v-col>-->
      <v-col cols="12">
        <base-material-card color="primary" inline title="Restaurantes">
          <v-row no-gutters class="text-no-wrap" align="center"
            ><v-col cols="12"
              ><v-simple-table>
                <thead>
                  <tr>
                    <th class="primary--text">Restaurante</th>
                    <th class="primary--text">Estado</th>
                    <th class="primary--text">Hora Inicio</th>
                    <th class="primary--text">Hora Fin</th>
                    <!-- <th class="text-right primary--text">Menú</th> -->
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(z, i) in getRestaurantesBossNegocio"
                    :key="i"
                    :class="
                      !!z.confTpv && z.confTpv.cierreEnCurso
                        ? 'blue lighten-5'
                        : i % 2 == 0
                        ? 'grey lighten-5'
                        : ''
                    "
                  >
                    <td>{{ z.nombre }}</td>
                    <td>{{ z.estado }}</td>
                    <td>{{ z.inicioZMostrar }}</td>
                    <td>{{ z.finZMostrar }}</td>
                    <!-- <td class="text-right">
                      <v-tooltip top v-if="z.estado == 'cerrado'">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="goView(z)"
                            class="px-2 ml-1"
                            color="info"
                            min-width="0"
                            small
                          >
                            <v-icon small>mdi-file-outbox-pdf</v-icon>
                          </v-btn>
                        </template>
                        <span> Ver fichero cierre </span>
                      </v-tooltip>
                    </td> -->
                  </tr>
                </tbody>
              </v-simple-table></v-col
            >
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

import { mostrarMoneda, idToTexto } from "@/utils/utils.js";
import moment from "moment-timezone";
import { mapGetters, mapState } from "vuex";
import CierreVista from "../../components/negocio/CierreVista.vue";
export default {
  components: {
    CierreVista,
  },
  data() {
    return {
      mesaDialogo: false,
      datosPedido: {},
      filtrosAcordeon: [],
      filtros: {
        cobrados: [],
        modos: [],
        formasPago: [],
        restaurantes: [],
        eliminado: false,
      },
    };
  },
  computed: {
    productosMejoresCabecera() {
      return [
        {
          text: "#",
          value: "index",
          sortable: false,
        },
        {
          text: "Nombre",
          value: "nombre",
          sortable: false,
        },
        {
          text: "Cantidad",
          value: "cantidad",
          sortable: true,
        },
        {
          text: "Total",
          value: "total",
          sortable: true,
        },
      ];
    },
    filtrosRestaurantes() {
      return [
        ...new Set(
          this.pedidosTodos.map((p) =>
            p.copyRest && p.copyRest.nombre
              ? { text: p.copyRest.nombre, value: p.restaurante }
              : { value: p.restaurante, text: p.restaurante }
          )
        ),
      ];
    },
    filtrosCobrados() {
      return [
        { text: "Cobrados", value: "cobrados" },
        { text: "Por cobrar", value: "por-cobrar" },
      ];
    },
    filtrosModo() {
      return [
        ...new Set(
          this.pedidosTodos.map((p) =>
            p.modoCopy && p.modoCopy.nombre
              ? { text: p.modoCopy.nombre, value: p.modoCopy.id }
              : { value: p.modo, text: p.modo }
          )
        ),
      ];
    },
    filtrosFormaPago() {
      return [
        ...new Set(
          this.pedidosTodos
            .map((p) => {
              return { text: p.formaPago, value: p.forma_pago };
            })
            .filter((f) => !!f.value)
        ),
      ];
    },
    pedidosTpvContabilizar(state, getters) {
      return this.pedidosTodosFiltrados.filter(
        (p) => p.estado == "tpv-realizando"
      );
    },
    pedidosOnlineContabilizar(state, getters) {
      return this.pedidosTodosFiltrados.filter((p) => p.estado == "finalizado");
    },
    numeroPedidosTpv(state, getters) {
      return this.pedidosTpvContabilizar.length;
    },
    numeroPedidosTotal(state, getters) {
      return this.pedidosTodosFiltrados.length.toString();
    },
    totalPedidosOnline(state, getters) {
      return this.pedidosOnlineContabilizar.reduce(
        (acc, val) => acc + parseFloat(val.precioTotal),
        0
      );
    },
    totalPedidosTpv(state, getters) {
      return this.pedidosTpvContabilizar.reduce(
        (acc, val) => acc + parseFloat(val.precioTotal),
        0
      );
    },
    pedidosTotal(state, getters) {
      return this.totalPedidosOnline + this.totalPedidosTpv;
    },
    pedidosTodos() {
      return this.$store.getters["pedidos/getPedidosListado"];
    },
    pedidosTodosFiltrados() {
      return this.pedidosTodos
        .map((p) => {
          let aux = { ...p };
          var bool = true;
          if (this.filtros.modos.length > 0)
            bool =
              bool &&
              this.filtros.modos.includes(p.modoCopy ? p.modoCopy.id : p.modo);

          if (this.filtros.cobrados.length > 0)
            bool =
              bool &&
              ((this.filtros.cobrados.includes("cobrados") && !!p.cobrado) ||
                (this.filtros.cobrados.includes("por-cobrar") && !p.cobrado));

          if (this.filtros.formasPago.length > 0) {
            let cobradoDesglose =
              p.cobradoDesglose && p.cobradoDesglose.length > 0
                ? p.cobradoDesglose
                : [];
            let cobradoDesgloseFiltrado = cobradoDesglose.filter((c) =>
              this.filtros.formasPago.includes(c.formaPago)
            );
            console.log(cobradoDesgloseFiltrado);
            bool = bool && cobradoDesgloseFiltrado.length > 0;
            if (cobradoDesgloseFiltrado.length > 0) {
              aux.precioTotal = cobradoDesgloseFiltrado.reduce(
                (acc, val) => acc + parseFloat(val.pagado),
                0
              );
            }
          }

          if (this.filtros.restaurantes.length > 0)
            bool = bool && this.filtros.restaurantes.includes(p.restaurante);

          return bool ? aux : false;
        })
        .filter((p) => !!p);
    },
    getPedidosListadoBossNegocioTpv() {
      return this.pedidosTodosFiltrados
        .map((p) => {
          let tz = !!p.copyRest.confGeneral.zonaHoraria
            ? p.copyRest.confGeneral.zonaHoraria
            : "Europe/Madrid";
          let actualMoment = moment(this.$store.state.pedidos.horaActual);
          let fechaMoment = moment(p.fechaServidor.toDate()).tz(tz);
          var durantion = moment.duration(actualMoment.diff(fechaMoment));
          return {
            ...p,
            nombreModo: p.modoCopy ? p.modoCopy.nombre : p.modo,
            fechaMostrarContador: parseInt(durantion.asMinutes()),
            fechaMoment: fechaMoment,
            fechaMostrar: moment(p.fechaServidor.toDate())
              .tz(tz)
              .format("HH:mm"),
            cantidadMostrar: mostrarMoneda(p.precioTotal),
            formaPago: idToTexto(p.forma_pago),
          };
        })
        .sort((a, b) => b.fechaMoment - a.fechaMoment);
    },
    ...mapState({
      zcierresAbiertosBruto: (state) => state.zcierres.zcierresAbiertos,
    }),
    ...mapGetters({
      negocioGestSlug: "app/negocioGestObj",
      numPedidosNegocio: "negocios/numPedidosNegocio",
      cantidadPedidos: "negocios/numCantidad",
      numRest: "negocios/numRestNegocio",
      //getPedidosListadoBossNegocioTpv: "pedidos/getPedidosListadoBossNegocioTpv",
      getPedidosListadoBossNegocioOnline:
        "pedidos/getPedidosListadoBossNegocioOnline",
      //getProductosListadoBossNegocio: "pedidos/getProductosListadoBossNegocio",
      getRestaurantesBossNegocioBruto:
        "restaurantes/getRestaurantesBossNegocio",
    }),
    getRestaurantesBossNegocio() {
      return this.getRestaurantesBossNegocioBruto.map((r) => {
        let fZ = this.zcierresAbiertosBruto.find(
          (z) => z.id === (r.confTpv ? r.confTpv.cierreEnCurso : null)
        );
        console.log(fZ);
        return {
          ...r,
          nombreMostrar: !!this.$store.state.app.negocioObjGest
            ? this.$store.state.app.negocioObjGest.nombre + " " + r.nombre
            : "",
          inicioZMostrar: !!fZ
            ? moment.unix(fZ.inicio).tz("Europe/Madrid").format("DD-MM HH:mm")
            : "-",
          finZMostrar:
            !!fZ && !!fZ.fin
              ? moment.unix(fZ.fin).tz("Europe/Madrid").format("DD-MM HH:mm")
              : "-",
        };
      });
    },
    productosMejores() {
      return this.getProductosListadoBossNegocio
        .filter((p) => p.cantidad > 0)
        .sort((a, b) => b.total - a.total);
    },
    getProductosListadoBossNegocio() {
      let res = this.pedidosTodosFiltrados
        .filter((p) => !p.eliminado)
        .map((pedido) => {
          return pedido.productos;
        })
        .flat();

      let res2 = Object.values(groupBy(res, "id")).map((arrayProductos) => {
        let prdComun = arrayProductos[0];
        console.log(prdComun);
        return {
          id: prdComun.id,
          nombre: prdComun.nombre,
          cantidad: arrayProductos.reduce((a, b) => a + (b.cantidad || 0), 0),
          total: arrayProductos.reduce(
            (a, b) => a + (b.precioProductoTotal || 0),
            0
          ),
          totalMostrar: mostrarMoneda(
            arrayProductos.reduce((a, b) => a + (b.precioProductoTotal || 0), 0)
          ),
        };
      });
      console.log(res2);
      return res2;
    },
  },
  methods: {
    imgCanal(canal) {
      switch (canal) {
        case "propio":
        case "funeats":
          return require("@/assets/logoFunEats.svg");
          break;
      }
    },
    goView(item) {
      //let str = "/admin/pedidos/view/" + item.id;
      //this.$router.push(str);
      this.datosPedido = item;
      this.mesaDialogo = true;
    },
    mostrarMoneda(v) {
      return mostrarMoneda(v, true);
    },
  },
  mounted() {
    console.log(this.$store.getters["negocios/numPedidosNegocio"]);
  },
};
</script>

<style lang="scss" scoped>
.tr-click {
  &:hover {
    cursor: pointer;
  }
}
</style>